// extracted by mini-css-extract-plugin
export default {"base":"ContentPage_base__DFbE0","head":"ContentPage_head__8pbyx","body":"ContentPage_body__uRCn+","inner":"ContentPage_inner__DFzRe"};